import {request} from '@/network/request'

/**
 * 旧版本
 * @param query
 * @returns {Promise<AxiosResponse<any>>}
 */
/*
export function fetchList(query) {
    return request({
        url: '/gaoligong/endemicPlant/page',
        method: 'get',
        params: query
    })
}

export function addObj(obj) {
    return request({
        url: '/gaoligong/endemicPlant',
        method: 'post',
        data: obj
    })
}

export function getObj(id) {
    return request({
        url: '/gaoligong/endemicPlant/' + id,
        method: 'get'
    })
}

export function delObj(id) {
    return request({
        url: '/gaoligong/endemicPlant/' + id,
        method: 'delete'
    })
}

export function putObj(obj) {
    return request({
        url: '/gaoligong/endemicPlant',
        method: 'put',
        data: obj
    })
}

 */

export function fetchList(data) {
    return request({
        url: '/gaoligong/specificplantdirectory/getSpecificPlantDirectoryList',
        method: 'post',
        data
    })
}

export function addObj(obj) {
    return request({
        url: '/gaoligong/specificplantdirectory',
        method: 'post',
        data: obj
    })
}

export function getObj(id) {
    return request({
        url: '/gaoligong/specificplantdirectory/' + id,
        method: 'get'
    })
}

export function delObj(id) {
    return request({
        url: '/gaoligong/specificplantdirectory/' + id,
        method: 'delete'
    })
}

export function putObj(obj) {
    return request({
        url: '/gaoligong/specificplantdirectory',
        method: 'put',
        data: obj
    })
}
